module.exports = __webpack_public_path__ + "static/media/landingBanner-tablet.9366d8ba.png";